import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {EcomsyncBranchContainerModel} from '../../../../../../models/aggregates/branch';
import {Core2Config} from '../../shared/core2Config';


@Injectable({
  providedIn: 'root'
})
export class EcomsyncBranchService extends BaseApiTemplateService<EcomsyncBranchContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'branches';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'branches';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'branches';
    this.httpClient = http;
  }

}
